'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.millisecondsSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/millisecondsSince.js
// module id = 571
// module chunks = 0